import { render, staticRenderFns } from "./bookings.vue?vue&type=template&id=76bec5e0&scoped=true"
import script from "./bookings.vue?vue&type=script&lang=js"
export * from "./bookings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76bec5e0",
  null
  
)

export default component.exports